export default "__VITE_ASSET__CLNZp1$q__"